<script setup lang="ts">
  import Button, { ButtonProps } from '@leaflink/stash/Button.vue';
  import Icon from '@leaflink/stash/Icon.vue';
  import { computed } from 'vue';

  const props = defineProps<ButtonProps & { loading?: boolean }>();

  const computedProps = computed(() => {
    const { loading, ...originalProps } = props;
    return { loading, originalProps };
  });
</script>

<template>
  <Button v-bind="computedProps.originalProps" class="tw-relative !tw-min-w-auto tw-px-[30px]">
    <span :class="{ 'tw-text-transparent': computedProps.loading }"><slot></slot></span>
    <span
      v-if="computedProps.loading"
      class="tw-flex tw-absolute tw-top-[50%] tw-left-[50%] tw-translate-x-[-50%] tw-translate-y-[-50%]"
    >
      <Icon class="fx-spin" name="loading-empty" size="dense" />
    </span>
  </Button>
</template>
